import { render, staticRenderFns } from "./HeaderOptions.vue?vue&type=template&id=21ddcab7&scoped=true&"
import script from "./HeaderOptions.vue?vue&type=script&lang=js&"
export * from "./HeaderOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ddcab7",
  null
  
)

export default component.exports